export function useChecked() {
  const checked = bool => bool ? 'x' : '';
  return {
    checked
  };
}